import { render, staticRenderFns } from "./Jixiaoman.vue?vue&type=template&id=f88645a6&scoped=true&"
import script from "./Jixiaoman.vue?vue&type=script&lang=js&"
export * from "./Jixiaoman.vue?vue&type=script&lang=js&"
import style0 from "./Jixiaoman.vue?vue&type=style&index=0&id=f88645a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88645a6",
  null
  
)

export default component.exports